import React from "react";
import { Product } from "~/common/Store/models/ProductListing";

interface Props {
  products: Product[];
}
const CarouselSchema = ({ products }: Props) => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    itemListElement: products.map((product, index) => ({
      "@type": "ListItem",
      position: index + 1,
      url: `https://www.webstaurantstore.com${product.link}`,
      name: product.header,
      image: `https://www.webstaurantstore.com${product.primaryImagePath}`,
    })),
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default CarouselSchema;
